import React from "react";
import { formatDateTime } from "../utils/formatters";
import { renderWithBold } from "../utils/textUtils";

const MessageBubble = ({ message }) => {
  const handleMenuClick = () => {
    window.location.reload();
  };

  const senderName = message.senderName ?? (message.isUser ? "" : "NAOL");

  return (
    <div className={`flex ${message.isUser ? "justify-end" : "justify-start"}`}>
      <div className={`flex gap-2 max-w-[85%] flex-row`}>
        {!message.isUser && (
          <img src="/naol.png" alt="NAOL" className="w-8 h-8 rounded-full object-cover flex-shrink-0" />
        )}
        <div className={`flex flex-col min-w-0 ${message.isUser ? "items-end" : "items-start"}`}>
          {/* Name and datetime on top */}
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-medium text-gray-800">{senderName}</span>
            {message.timestamp && (
              <span className="text-xs text-gray-500">{formatDateTime(message.timestamp)}</span>
            )}
          </div>
          {/* Message bubble - icon outside, so bubble contains only content */}
          <div className={`rounded-2xl px-4 py-2 text-sm ${
            message.isUser
              ? "bg-[#E7E5E1] text-gray-800"
              : "bg-white text-gray-800 shadow-sm border border-gray-100"
          }`}>
        <p className="leading-relaxed whitespace-pre-wrap break-words" style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
          <span>{renderWithBold(message.text)}</span>
        </p>
        {message.showIcons && message.iconLinks && (
          <div className="mt-3 flex items-center justify-center gap-4">
            {/* Android Icon */}
            <button
              onClick={() => window.open(message.iconLinks.android, "_blank", "noopener,noreferrer")}
              className="flex items-center justify-center w-12 h-12 rounded-xl bg-white border border-gray-200 hover:bg-[#E7E5E1] hover:border-[#0074bc] transition-colors shadow-sm"
              aria-label="Download Android App"
              title="Download Android App"
            >
              <img src="/Google_Play.svg" alt="Google Play" className="w-6 h-6" />
            </button>

            {/* iOS Icon */}
            <button
              onClick={() => window.open(message.iconLinks.ios, "_blank", "noopener,noreferrer")}
              className="flex items-center justify-center w-12 h-12 rounded-xl bg-white border border-gray-200 hover:bg-[#E7E5E1] hover:border-[#0074bc] transition-colors shadow-sm"
              aria-label="Download iOS App"
              title="Download iOS App"
            >
              <img src="/App_Store.svg" alt="App Store" className="w-6 h-6" />
            </button>

            {/* Website Icon */}
            <button
              onClick={() => window.open(message.iconLinks.website, "_blank", "noopener,noreferrer")}
              className="flex items-center justify-center w-12 h-12 rounded-xl bg-white border border-gray-200 hover:bg-[#E7E5E1] hover:border-[#0074bc] transition-colors shadow-sm"
              aria-label="Visit Website"
              title="Visit Website"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z" fill="#0074bc"/>
              </svg>
            </button>
          </div>
        )}
        {message.showMenuButton && (
          <button
            onClick={handleMenuClick}
            className="mt-3 px-4 py-2 bg-[#0074bc] text-white text-xs font-semibold rounded-lg hover:bg-[#1a6ba0] transition-colors w-full"
          >
            Go to Main Menu
          </button>
        )}
        {message.options && message.options.length > 0 && (
          <div className="mt-3 flex flex-col gap-2.5">
            {message.options.map((opt, idx) => (
              <button
                key={idx}
                onClick={() => message.onOptionClick && message.onOptionClick(opt)}
                disabled={message.disabled}
                className="w-full px-4 py-2.5 text-sm rounded-xl bg-white border border-gray-200 text-gray-800 hover:bg-[#E7E5E1] hover:border-[#0074bc] transition-colors disabled:opacity-60 shadow-sm text-left flex items-center"
              >
                {opt}
              </button>
            ))}
          </div>
        )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;

